import React from "react";

const BASE_WIDTH = 32;
const BASE_HEIGHT = 31;

interface OwnProps {
  width?: number;
  height?: number;
  rotation?: string | number;
  color?: string;
}
export default function ExpandAccordianIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${props.rotation || 0})`}
    >
      <path
        d="M13.3897 20.3612C13.072 20.6789 13.072 21.194 13.3897 21.5117V21.5117C13.7074 21.8294 14.2225 21.8294 14.5402 21.5117L19.6928 16.359C20.0833 15.9685 20.0833 15.3353 19.6928 14.9448L14.5402 9.79217C14.2225 9.47447 13.7074 9.47447 13.3897 9.79217V9.79217C13.072 10.1099 13.072 10.625 13.3897 10.9427L18.0989 15.6519L13.3897 20.3612Z"
        fill={props.color ?? "#4D4D4D"}
      />
    </svg>
  );
}
